import React, {useEffect, ReactElement} from 'react';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import {useBoolean} from 'src/hooks/useBoolean';
import Button from '../button';
import icons from './icons';

import styles from './styles.module.scss';

interface IconPickerProps {
  value: string;
  onSelect: (value: string) => void;
}

const IconPicker = ({value, onSelect}: IconPickerProps): ReactElement => {
  const pickerShown = useBoolean(false);

  useEffect(() => {
    if (!value) {
      onSelect(icons[0]);
    }
  }, [onSelect, value]);

  return (
    <Tooltip
      title={icons.map(
        (icon): ReactElement => (
          <Icon
            key={icon}
            className={styles.iconButton}
            onClick={(): void => {
              onSelect(icon);
              pickerShown.setFalse();
            }}
            iconType={icon}
          />
        )
      )}
      open={pickerShown.value}
    >
      <span>
        <Button outline onClick={pickerShown.toggle}>
          <Icon iconType={value} />
        </Button>
      </span>
    </Tooltip>
  );
};

export default IconPicker;
